import { types, actions } from './requests'
export const UPDATEMACHINE_TYPES = {
    ...types('UPDATEMACHINE'),
}
export const UPDATEMACHINE_ACTIONS = {
    ...actions('UPDATEMACHINE'),
}
